<template>
  <v-row>
    <v-col cols="12">
      <p class="gray--text form__title mb-5">
        ESCOLHA DA APÓLICE PARA SOLICITAÇÃO/CRIAÇÃO DE ENDOSSO
      </p>
    </v-col>
    <v-col cols="12">
      <p class="primary--text form__label mb-2">
        Grupo Econômico
      </p>
      <BaseSelect
        placeholder="Razão Social / CNPJ"
        v-model="selectedEconomicGroup"
        :items="listEconomicGroup"
        item-text="nome"
        item-value="id"
        :return-object="true"
      />
    </v-col>
    <v-col cols="12">
      <p class="primary--text form__label mb-2">
        Tomador Matriz/Filial
      </p>
      <BaseSelect
        placeholder="Razão Social / CNPJ"
        v-model="selectedTaker"
        :items="listTaker"
        item-text="nome_fantasia"
        item-value="id"
        :return-object="true"
      />
    </v-col>
    <v-col cols="12">
      <p class="primary--text form__label mb-2">
        Filtro Apólice
      </p>
      <BaseFilter
        v-model="filterPolicy"
        :textPlaceholder="'Número da Apólice'"
        v-bind="defaultConfigs"
      />
    </v-col>
    <v-col cols="12" class="pb-6">
      <v-divider />
    </v-col>
    <v-col cols="12">
      <BaseDataTable
        :headers="tableHeaders"
        :items="listPolicy"
        :search="filterPolicy"
        no-data-text="Nenhuma Apólice foi encontrado"
        loading-text="Carregando Apólices..."
        @click:row="updateSelectedPolicy"
      >
        <template v-slot:[`item.valor_importancia_segurada`]="{ item }">
          {{ asMoneyString(item.valor_importancia_segurada) }}
        </template>
        <template v-slot:[`item.inicio_vigencia`]="{ item }">
          {{ formatDateToDDMMYYYY(item.inicio_vigencia) }} a
          {{ formatDateToDDMMYYYY(item.fim_vigencia) }}
        </template>
        <template v-slot:[`item.situacao`]="{ item }">
          {{ item.situacao.nome }}
        </template>
        <template v-slot:[`item.tomador.cnpj`]="{ item }">
          {{ formatCpfOrCnpf(item.tomador.cnpj) }}
        </template>
        <template v-slot:[`item.tomador.subsidiaria`]="{ item }">
          {{ types[item.tomador.subsidiaria] }}
        </template>
      </BaseDataTable>
    </v-col>
  </v-row>
</template>
<script>
const defaultPropsFilter = {
  outlined: true,
  dense: true,
  "background-color": "white",
  class: "filter__icon",
  "append-outer-icon": "fa-search"
};
const tableHeaders = [
  { text: "Apólice", value: "numero", sortable: true },
  {
    text: "Importância Segurada",
    value: "valor_importancia_segurada",
    sortable: true
  },
  { text: "Vigência", value: "inicio_vigencia", sortable: true },
  { text: "Status", value: "situacao", sortable: true },
  { text: "Tomador", value: "tomador.nome_fantasia", sortable: true },
  { text: "CNPJ", value: "tomador.cnpj", sortable: true },
  { text: "Matriz ou Filial", value: "tomador.subsidiaria", sortable: true }
];
import {
  formatCpfOrCnpf,
  asMoneyString,
  formatDateToDDMMYYYY
} from "@/utils/formats";
import { mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
export default {
  mixins: [LoadingRequest],
  data: () => ({
    filterPolicy: null,
    selectedEconomicGroup: null,
    selectedTaker: null,
    tableHeaders,
    types: { false: "MATRIZ", true: "FILIAL" },
    formatCpfOrCnpf,
    asMoneyString,
    formatDateToDDMMYYYY,
    listEconomicGroup: [],
    listTaker: [],
    listPolicy: []
  }),
  created() {
    this.fetchListEconomicGroup();
  },
  computed: {
    defaultConfigs() {
      return {
        ...defaultPropsFilter
      };
    }
  },
  methods: {
    ...mapActions("endorsement", [
      "requestListEconomicGroup",
      "requestListTaker",
      "requestListPolicy"
    ]),
    fetchListEconomicGroup() {
      this.withLoading(
        this.requestListEconomicGroup().then(data => {
          this.listEconomicGroup = data;
        })
      );
    },
    fetchListTaker() {
      this.withLoading(
        this.requestListTaker(this.selectedEconomicGroup.id).then(data => {
          this.listTaker = data;
        })
      );
    },
    fetchListPolicy() {
      const payload = `?tomador_id=${this.selectedTaker.id}`;
      this.withLoading(
        this.requestListPolicy(payload).then(data => {
          this.listPolicy = data.items;
        })
      );
    },
    updateSelectedPolicy(item) {
      this.$emit("select", item);
    }
  },
  watch: {
    selectedTaker(value) {
      if (value) this.fetchListPolicy();
    },
    selectedEconomicGroup(value) {
      if (value) this.fetchListTaker();
    }
  }
};
</script>
